export const transition = {
    type: "spring",
    duration: 0.7,
    bounce: 0.2
  };
